import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ReminderEntity } from '../../domain/entities/ReminderEntity'
import type { ReminderAttemptAdminDto } from '@/backend/market'

export class ReminderModel extends ReminderEntity {
  constructor(dataDto: ReminderAttemptAdminDto) {
    super()
    mapEntityProperties<ReminderEntity>(this, dataDto)
  }
}
